import React from 'react';
import styled from '@emotion/styled';
import Button from '../../../components/Button';
import { useGlobalContext } from '../../state/GlobalContext';
interface CancelButtonProps {
  subscription: Subscription;
  isStubbedData?: boolean;
  handleStubDataChanges: () => void;
  onCancelModalOpen: () => void;
  t: (key: string) => string;
}

const CancelButton = ({
  subscription,
  isStubbedData,
  handleStubDataChanges,
  onCancelModalOpen,
  t,
}: CancelButtonProps): React.ReactElement | null => {
  const { customerPortalSettings } = useGlobalContext();
  const merchantSettingHideCancel = customerPortalSettings?.hideCancel;
  const isCancelled = subscription?.SubscriptionStatus === 'CANCELLED';
  const isExpired = subscription?.SubscriptionStatus === 'EXPIRED';
  const isPaused = subscription?.SubscriptionStatus === 'PAUSED';
  const isPrepaidV2 = subscription?.Lines?.some(({ PrepaidV2 }) => PrepaidV2);
  const isPrepaidV3 = subscription?.Lines?.some(
    ({ PrepaidVersion }) => PrepaidVersion === 3,
  );
  const isPrepaidV1 =
    subscription?.HasPrepaidLines && !isPrepaidV2 && !isPrepaidV3;
  const isBillingOrUpdatingOrScheduled =
    subscription?.IsBilling ||
    subscription?.IsUpdating ||
    subscription?.IsBillingScheduled;
  const isAutorenew = !subscription.BillingPolicyMaxCycles;

  const shouldShowCancelButton = () => {
    if (isPrepaidV2 || isPrepaidV3) {
      return isExpired ? false : !!isAutorenew;
    } else {
      return !!(
        !isCancelled &&
        !isBillingOrUpdatingOrScheduled &&
        !merchantSettingHideCancel &&
        !isPrepaidV1
      );
    }
  };

  return shouldShowCancelButton() ? (
    <CustomButton
      className="bundle-button--cancel"
      color="danger"
      fullWidth
      disabled={isCancelled || isPaused}
      onClick={() => {
        isStubbedData ? handleStubDataChanges() : onCancelModalOpen();
      }}
    >
      {t('subscription.cancel_subscription')}
    </CustomButton>
  ) : null;
};

const CustomButton = styled(Button)`
  height: 44px;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export default CancelButton;
